import { HiShieldCheck } from "react-icons/hi";
import { MdQueue, MdAnalytics } from "react-icons/md";
const data = [
  {
    icon: <HiShieldCheck/>,
    heading: "Bahan Kualitas Premium",
    detail:
      "Produk menggunakan bahan berkualitas premium terbaik yang menjamin daya tahan tinggi. Keunggulan bahan ini tidak hanya terletak pada estetika, tetapi juga pada performa dan ketahanannya terhadap penggunaan sehari-hari.",
  },
  {
    icon: <MdAnalytics />,
    heading: "Kelengkapan Bahan",
    detail:
      "Tersedia berbagai macam variasi sticker sehingga customer dapat memilih banyak pilihan warna dan jenis sticker yang ada",
  },
  {
    icon: <MdQueue  />,
    heading: "Preorder Custom",
    detail:
      "1.Hubungi admin melalui whatsapp 2.Tanyakan mengenai custom yang diinginkan 3.Konfirmasi dan pemabayaran awal 4.Ditunggu proses pencetakan 5.Dihubungi oleh admin siap pasang 6.Pembayaran lunas",
  },
];
export default data;